import { type AdditionalServices } from 'src/features/parkingManagement/types/additionalServices';
import { CURRENCIES } from 'src/features/payStations/types';

export enum RESERVATION_TYPE {
    HOURLY = 'hourly',
    DAILY = 'daily',
    FIXED_DURATION = 'fixed-duration',
}

export type ReservationType = {
    id: string;
    reservation_type: RESERVATION_TYPE;
    name: string;
    description: string;
    version_number: number;
    enabled: boolean;
    allowed_spaces: number;
    currency: CURRENCIES;
    reserve_space: boolean;
    entry_tolerance_minutes: number;
    exit_tolerance_minutes: number;
    valid_from: string;
    valid_to: string | null;
    total_reservations_count: number;
    active_reservations_count: number;
    upcoming_reservations_count: number;
    scheduled_versions_count: number;
    total_versions_count: number;

    fixed_duration_start: string | null;
    fixed_duration_end: string | null;
    points: string[];

    paid: boolean;

    price?: number;
    tax_percent?: string;
    tax_amount?: number;
    price_with_tax?: number;

    zones?: string[];
    allow_lists?: string[];
    max_duration?: number;
    max_start_date_days?: string;
};

export enum PAYMENT_STATUS {
    PENDING = 'pending',
    SUCCESSFUL = 'successful',
    FAILED = 'failed',
    REFUNDED = 'refunded',
}

type VehicleStayReservationType = {
    id: string;
    reservation_type: RESERVATION_TYPE;
    name: string;
    version_number: number;
    currency: CURRENCIES;
};

export enum RESERVATION_STATUS {
    WAITING_PAYMENT = 'waiting-payment',
    UPCOMING = 'upcoming',
    ACTIVE = 'active',
    PAST = 'past',
    FAILED_PAYMENT = 'failed-payment',
    CANCELLED = 'cancelled',
}

export type ReservationsVehicleStayList = {
    id: string;
    vehicle_stay_reservation_type: VehicleStayReservationType;
    payment_status: PAYMENT_STATUS;
    license_plate: string | null;
    number: string;
    from_time: string;
    to_time: string;
    cancelled: boolean;
    cancelled_at: string | null;
    created_at: string;
    price: number;
    tax_amount: number;
    price_with_tax: number;
    client_email: string;
    client_name: string;
    client_phone: string;
    status: RESERVATION_STATUS;
    membership_group_id: string;
    from_time_with_tolerance: string;
    to_time_with_tolerance: string;
    additional_services: AdditionalServices[];
    does_membership_exists: boolean;
};

export type VersionFormDisplayedValues = {
    tax_amount: string;
    price: string;
    price_with_tax: string;
    tax_percent: string;
    currency: CURRENCIES;
};

export enum PAYMENT_ORDER_STATUS {
    PENDING = 'pending',
    PAID = 'paid',
    COMPLETED = 'completed',
    CANCELLED = 'cancelled',
    FAILED = 'failed',
    ROLLBACK = 'rollback',
    REFUNDED = 'refunded',
}

enum PROVIDER {
    DSK = 'dsk',
    MYPOS = 'mypos',
    BORICA = 'borica',
}

export type ReservationPaymentOrder = {
    id: string;
    status: PAYMENT_ORDER_STATUS;
    date: string;
    provider: PROVIDER;
    number: string | null;
    payment_transaction_number: string;
    due_amount: number;
    tax_percent: string;
    tax_amount: number;
    due_amount_with_tax: number;
    client_ip: string;
    payment_completed_at: string;
    created_at: string;
};
